module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hans/2-c07641004762092763a3a9838a7e1ae1.jpg";